import React, { useState, useEffect } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Button,
  Modal,
  ModalHeader,
  ModalBody
} from "reactstrap"
import BootstrapTable from 'react-bootstrap-table-next'
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit'
import rest from '../../../lib/rest'
import rotas from '../../../services/rotas'
import useToggle from "../../../lib/useToggle"
import Loading from 'lib/loading'
import FormPerfil from './formPerfil'
// import ModalForm from './modalForm'

const Perfis = () => {

  const colunas = [
    {
      dataField: 'perfil_id',
      text: 'Código'
    },
    {
      dataField: 'nome_perfil',
      text: 'Perfil acesso'
    }
  ]

  const { SearchBar }                 = Search
  const [loading, setLoading]         = useState(true)
  const [modal, setModal]             = useToggle()
  const [listaPerfil, setListaPerfil] = useState([])
  const [perfil_id, setPerfil_id]     = useState('')

  const listaPerfis = () => {
    let lista = []
    try{
      const retorno = rest.get(rotas.perfil)
      retorno.then(ret => {
        if (ret.success){
          lista = ret.lista
          setListaPerfil(lista)
          setLoading(false)
        }
      })
      return (lista)
    }catch(err){
    }
  }

  useEffect(() => {
    const load = loading
    if (load === true) {
      listaPerfis()
    }
  }, [])

  const abreModal = (perfil_id) => {
    setPerfil_id(perfil_id)
    setModal()
  }

  useEffect(() => {
    if(modal===false){
      listaPerfis()
    }
  }, [modal])

  if (loading) {
    return (
      <Loading
        tipo='paginas'
      />
    )
  }else {
    return (
      <div className="content">
        <Container>
          <Row>
            <Col md="12" className="p-0">
              <Card>
                <CardHeader>
                  <CardTitle>CADASTRO DE PERFIS</CardTitle>
                </CardHeader>
                <CardBody>
                  <Modal
                    size    = 'xl'
                    isOpen  = {modal}
                  >
                    <ModalHeader>Cadastro de Perfis</ModalHeader>
                    <FormPerfil
                      perfil_id  = {perfil_id}
                      fechaModal  = {setModal}
                    ></FormPerfil>
                  </Modal>
                  <ToolkitProvider
                    search
                    keyField  = "perfil_id"
                    data      = {listaPerfil}
                    columns   = {colunas}
                    outline
                  >
                    {
                      props => (
                        <div>
                          <Container>
                            <Row>
                              <Col md="3">
                                <Button
                                  outline
                                  className = "m-0 w-100"
                                  color     = "primary"
                                  style     = {{ padding: '5px 20px' }}
                                  onClick   = {() => abreModal('')}
                                >
                                  <i className="fas fa-plus" />
                                  Cadastrar
                                </Button>
                              </Col>

                              <Col md="9">
                                <SearchBar
                                  placeholder = "Buscar Perfil..."
                                  style       = {{ padding: '5px' }}
                                  {...props.searchProps}
                                />
                              </Col>
                            </Row>
                          </Container>

                          <hr/>

                          <BootstrapTable
                            striped
                            // remote
                            keyField          = 'perfil_id'
                            noDataIndication  = "Nenhum registro encontrado"
                            rowStyle          = {{ cursor: "pointer" }}
                            rowEvents         = {{
                                                  onDoubleClick: (e, row, rowIndex) => {
                                                    abreModal(row.perfil_id)
                                                  }
                                                }}
                            {...props.baseProps}
                          />
                          <br/>
                        </div>
                      )
                    }
                  </ToolkitProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }

}

export default Perfis
